/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _AdverseEventEditionForm;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { service } from "@ember/service";
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import AdverseEventDeclaredJournalEvent from "core/models/adverse-event-declared-journal-event";
import SemeiaSessionService from "core/services/session";
import validateSometimes from "core/validators/sometimes";
import { EmberChangeset } from "ember-changeset";
import { validatePresence } from "ember-changeset-validations/validators";
import { ValidatorMap } from "ember-changeset/types";
import IntlService from "ember-intl/services/intl";
import styles from "./index.module.css";
let AdverseEventEditionForm = (_class = (_AdverseEventEditionForm = class AdverseEventEditionForm extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
  }
  get validations() {
    const validations = this.journalEventClass.validations(this.intl);
    validations["otherDetails"] = validateSometimes([validatePresence({
      presence: true,
      description: "Le symptôme"
    })], function () {
      return this.get("adverseEventId") == "other";
    });
    validations["evaScore"] = validateSometimes([validatePresence({
      presence: true,
      description: "Le degré de gêne ou de douleur"
    })], function () {
      return Boolean(this.get("shouldShowEva"));
    });
    return validations;
  }
  get title() {
    return this.intl.t("vital-sign.adverse-events.long-description");
  }
  get otherIsSelected() {
    return this.changeset.get("adverseEventId") == "other";
  }
  get selectedAdverseEventId() {
    return this.changeset.get("adverseEventId");
  }
  selectAdverseEvent(adverseEvent) {
    this.changeset.set("adverseEventId", adverseEvent.id);
    this.changeset.set("shouldShowEva", true);
  }
  get adverseEvents() {
    return (this.args.patient.followUpReasonRecord?.adverseEvents ?? []).slice();
  }
  get selectedAdverseEvent() {
    return this.adverseEvents.find(adverseEvent => adverseEvent.id == this.selectedAdverseEventId);
  }
}, _defineProperty(_AdverseEventEditionForm, "fullComponentId", "adverse-event/edition-form"), _defineProperty(_AdverseEventEditionForm, "forcDisplayName", "Symptôme"), _defineProperty(_AdverseEventEditionForm, "journalEventClass", AdverseEventDeclaredJournalEvent), _AdverseEventEditionForm), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "selectAdverseEvent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectAdverseEvent"), _class.prototype), _class);
export { AdverseEventEditionForm as default };